var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoNike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.337,
    height: 16,
    viewBox: "0 0 31.337 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.239 0l-.315 3.694L10.276 0h2l-3.05 8.412H7.255L7.5 4.368 6.032 8.412H4.06L7.088 0zm5.468 0l-3.046 8.412H9.668L12.713 0zm2.4 3.678l.15 4.211L20.04.179 19.9.3zm2.53 3.054l2.134-.013-.266.754 9.828-2.626-22.888 9.914c-2.48 1.083-6.378 2.293-8.006-.361-.907-1.481-.332-3.77 1.008-5.866a29.117 29.117 0 0 1 3.045-3.79c-.619 1-2.322 4.348-.074 6.02.864.658 2.4.732 4.305.217L18.06 8.41h-2.65l-.025-3.594L14.1 8.413h-1.985L15.143 0h1.988L16.2 2.446 18.223 0h5.583l-.566 1.564h-1.731l-.595 1.673h1.718L22.1 4.722h-1.731z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNike);
export default __webpack_public_path__ + "static/media/logo-nike.503c8e58.svg";
export { ForwardRef as ReactComponent };